/**
 * In-memory API cache for expensive operations
 * Auto-expires after TTL
 */

interface CacheEntry {
  data: any;
  timestamp: number;
  ttl: number; // in milliseconds
}

const cache: Map<string, CacheEntry> = new Map();

export function getCacheKey(endpoint: string, params: any = {}): string {
  const paramStr = JSON.stringify(params);
  return `${endpoint}:${paramStr}`;
}

export function getCachedData(key: string): any | null {
  const entry = cache.get(key);
  
  if (!entry) return null;
  
  const now = Date.now();
  const isExpired = now - entry.timestamp > entry.ttl;
  
  if (isExpired) {
    cache.delete(key);
    return null;
  }
  
  return entry.data;
}

export function setCachedData(key: string, data: any, ttlSeconds: number = 3600): void {
  cache.set(key, {
    data,
    timestamp: Date.now(),
    ttl: ttlSeconds * 1000,
  });
}

export function clearCache(): void {
  cache.clear();
}

export function getCacheStats(): { size: number; entries: string[] } {
  return {
    size: cache.size,
    entries: Array.from(cache.keys()),
  };
}
